import type { NextWorkflowError } from 'models/NextWorkflowError';
import { connect } from 'react-redux';
import { commonFormActions } from 'state/forms/actions/form';
import { getRejections } from 'state/forms/rejections/selectors';
import { isProductModification } from 'state/productModificationForm/productModificationForm.selector';
import { getIsUserInternal, isPendingEnrichment } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

interface StateProps {
  isGenerateAllProductCodesVisible: boolean;
  isGenerateAllProductCodesReadonly: boolean;
  errors: readonly NextWorkflowError[] | undefined;
}

interface DispatchProps {
  onGenerateCodes: () => void;
}

export type ProductCodesProps = DispatchProps & ProductNodeBuilderProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: ProductNodeBuilderProps): StateProps => {
  // TODO: handle all workspace type including PostTrade as this component can be used in TechModif
  const isLinkedToProductModification = isProductModification(state, tabId);
  const isGenerateAllProductCodesVisible = getIsUserInternal(state) && !isLinkedToProductModification;
  const isGenerateAllProductCodesReadonly = isPendingEnrichment(state, tabId);

  return {
    isGenerateAllProductCodesVisible,
    isGenerateAllProductCodesReadonly,
    errors: getRejections(state, tabId),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { tabId, workspaceType }: ProductNodeBuilderProps,
): DispatchProps => ({
  onGenerateCodes() {
    if (commonFormActions.isHandled(workspaceType)) {
      dispatch(commonFormActions.productCodesRequested(workspaceType, tabId));
    }
  },
});

export const connectProductCodes = connect(mapStateToProps, mapDispatchToProps);
